import React from 'react';
import './TermsPage.css';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-black">
      <div className="bg-gradient-to-r from-teal-800 to-cyan-900 w-full">
        <div className="max-w-6xl mx-auto text-center py-16 px-4">
          <h1 className="text-4xl font-bold text-white mb-2">Terms of Service</h1>
          <p className="text-teal-100 max-w-2xl mx-auto">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>
      
      <div className="max-w-3xl mx-auto px-6">
        <div className="terms-content py-16 text-left">
          <section className="mb-8">
            <p className="terms-intro text-lg">
              These Terms of Service ("Terms") govern your use of the elef89 platform. By using our service, you agree to these Terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">1. About elef89</h2>
            <p>
              elef89 provides an automated service that helps you upload your mobile applications to app stores (such as Google Play or Apple App Store). You remain fully responsible for your application, its content, and compliance with app store policies.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">2. Your Responsibilities</h2>
            <p className="mb-3">
              You are responsible for the accuracy of the information you provide, including app store credentials and app details.
            </p>
            <p className="mb-3">
              You are responsible for ensuring that your app complies with the rules, policies, and requirements of each app store.
            </p>
            <p>
              elef89 acts only as a technical service provider to facilitate the upload process — we are not involved in your relationship with the app stores.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">3. Disclaimer Regarding App Stores</h2>
            <p className="mb-3">
              Please be aware that app store approval, availability, and compliance decisions are fully controlled by the respective stores (such as Google Play, Apple App Store, etc.).
            </p>
            <p className="mb-3">
              elef89 cannot guarantee that your app will be accepted, approved, or remain available on any app store.
            </p>
            <p className="mb-3">
              We are not responsible for actions taken by the app stores, including app removal, rejection, suspension of your developer account, or any related consequences.
            </p>
            <p className="mb-3">
              We also reserve the right to discontinue the elef89 service, including closing the elef89 store, at our discretion.
            </p>
            <p>
              We recommend that you regularly back up your apps and keep a copy of your app files.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">4. License and Use</h2>
            <p className="mb-3">
              We grant you a limited, non-exclusive, non-transferable license to use elef89 solely for the purpose of uploading your apps through our service. You may not:
            </p>
            <ul className="mb-4 ml-6 space-y-2 list-disc">
              <li>Reverse engineer, decompile, or modify the platform</li>
              <li>Use the service for unlawful purposes</li>
              <li>Resell or sublicense the service to others without our permission</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">5. Intellectual Property</h2>
            <p>
              All content and features of the elef89 platform remain the exclusive property of elef89 and are protected by applicable intellectual property laws.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">6. No Warranty</h2>
            <p>
              The elef89 service is provided "as is" and "as available" without any warranties of any kind, including implied warranties of merchantability, fitness for a particular purpose, or non-infringement.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">7. Limitation of Liability</h2>
            <p className="mb-3">
              To the maximum extent permitted by law, elef89 and its affiliates shall not be liable for any indirect, incidental, special, or consequential damages, including but not limited to:
            </p>
            <ul className="mb-4 ml-6 space-y-2 list-disc">
              <li>Loss of data</li>
              <li>Loss of profits</li>
              <li>App rejection or removal by any store</li>
              <li>Suspension or closure of your app store account</li>
              <li>Closure or suspension of the elef89 service</li>
            </ul>
            <p>
              Your use of elef89 is at your own risk.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">8. Termination</h2>
            <p>
              We reserve the right to suspend or terminate your access to elef89 at our discretion, particularly if you violate these Terms or engage in harmful or unlawful activities.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">9. Changes to These Terms</h2>
            <p>
              We may update these Terms from time to time. Continued use of elef89 after changes are posted constitutes your acceptance of the revised Terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">10. Contact</h2>
            <p className="mb-2">
              If you have any questions about these Terms, please contact us at:
            </p>
            <p className="contact-info">
              📧 <a href="mailto:davidd@elef89.com" className="text-teal-400 hover:text-teal-300">davidd@elef89.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsPage; 